var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var ScormPostController = {
    /*****************************************************************************************************
        * Is using route "api/post/ScormCourse" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {File} tileFrontMedia
        * @param {File} tileBackMedia
        * @param {ScormCourseUploadDto} data
        * @param {{[key: string]: File}} packages
        * @returns {ScormCourseDownloadDto}
    ******************************************************************************************************/
    PostScormCourse: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        if (data.tileFrontMedia)
            fd.append("tileFrontMedia", data.tileFrontMedia);
        if (data.tileBackMedia)
            fd.append("tileBackMedia", data.tileBackMedia);
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.packages, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/ScormCourse", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/post/ScormCourse/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {File} tileFrontMedia
        * @param {File} tileBackMedia
        * @param {ScormCourseUploadDto} data
        * @param {{[key: string]: File}} packages
        * @returns {ScormCourseDownloadDto}
    ******************************************************************************************************/
    PatchScormCourse: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        if (data.tileFrontMedia)
            fd.append("tileFrontMedia", data.tileFrontMedia);
        if (data.tileBackMedia)
            fd.append("tileBackMedia", data.tileBackMedia);
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.packages, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/ScormCourse/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=ScormPostController.js.map